import React from 'react'

import { Caption } from 'ui/acro'

const MobileMenuLink = ({ open, ...props }) => (
  <Caption
    variant='hard'
    fontSize='16px'
    pt='15px'
    pb='14px'
    px='15px' // Inset
    color='black'
    className='unstyled'
    fontWeight='500'
    tabIndex={open ? '0' : '-1'}
    {...(props?.href && {
      as: 'a'
    })}
    {...props}
  />
)

export default MobileMenuLink
